import { alpha, createTheme, Theme } from '@mui/material';

import { globalTheme } from '../../../../../shared/theme/theme';

export const filterTheme: Theme = createTheme(globalTheme, {
  components: {
    MuiFormControl: {
      styleOverrides: {
        root: {
          display: 'block',
          flex: 1,
          '&.form-control-main': {
            width: '100%',
            height: '56px',
            marginTop: '62px',
            marginBottom: '36px',

            '& [id^="multiple-checkbox"]': {
              '&[data-shrink="true"]': {
                color: alpha(globalTheme.palette.black.main, 0.87),
              },
            },
          },

          '& .dropdown-autocomplete': {
            height: '56px',
            '& > div > div': {
              height: '56px',
              borderRadius: '4px',
            },
            svg: {
              fill: globalTheme.palette.primary.main,
            },
            borderRadius: '4px',
            backgroundColor: globalTheme.palette.appWhite.main,

            '&.Mui-disabled': {
              backgroundColor: globalTheme.palette.appGrey.whiteSmoke,
              color: 'rgba(0, 0, 0, 0.15)',
            },

            '&.Mui-disabled svg': {
              fill: globalTheme.palette.appGrey.darkGray,
            },
          },

          '& .datepicker': {
            backgroundColor: globalTheme.palette.appWhite.main,
            '& > div': {
              width: '100%',
            },
            svg: {
              fill: globalTheme.palette.primary.main,
            },
          },
        },
      },
    },

    MuiFilledInput: {
      styleOverrides: {
        root: {
          backgroundColor: globalTheme.palette.appWhite.main,
          border: 'solid',
          borderColor: globalTheme.palette.appGrey.lightSilver,
          borderWidth: '1px',

          '&.input-focused, &:hover': {
            backgroundColor: globalTheme.palette.appWhite.main,
            borderColor: 'none',
            borderWidth: 'none',
          },

          '&.Mui-disabled svg': {
            fill: globalTheme.palette.appGrey.darkGray,
          },
        },
        underline: {
          '&&&:before': {
            borderBottom: 'none',
          },
          '&&:after': {
            borderBottom: 'none',
          },
        },
      },
    },

    MuiPaper: {
      styleOverrides: {
        root: {
          boxShadow:
            'rgba(0, 0, 0, 0.1) 0px 5px 5px -3px, rgba(0, 0, 0, 0.03) 0px 8px 10px 1px, rgba(0, 0, 0, 0.05) 0px 3px 14px 2px',
        },
      },
    },
  },
});
